module.exports = __webpack_public_path__ + "img/order_icon.96a138c4.svg";